import { render, staticRenderFns } from "./AddBankAccountModal.vue?vue&type=template&id=2aad8896&"
import script from "./AddBankAccountModal.vue?vue&type=script&lang=ts&"
export * from "./AddBankAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddBankAccountModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports